import PropTypes from "prop-types";
import { FullScreenWrapper } from "../components/atoms/FullScreenWrapper";
import { Spin } from "antd";
import { useAuth0 } from "@auth0/auth0-react";

export const AuthGuardWithAuth0 = ({ children }) => {
  const { loginWithRedirect, isLoading, isAuthenticated } = useAuth0();

  if (isLoading) {
    return (
      <FullScreenWrapper>
        <Spin />
      </FullScreenWrapper>
    );
  }

  if (!isAuthenticated) {
    loginWithRedirect();
    return null;
  }

  return children;
};

AuthGuardWithAuth0.propTypes = {
  children: PropTypes.node,
};
